import React from 'react'
import { Pipeline, TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import { TriggerPipelineOnNavigate } from '@morningtrain/react-navigation'
import { MountSmartviewOnPipe, MountSmartviewWithModelOnPipe } from '@morningtrain/react-smartviews'
import ManageRolesSmartview from './smartviews/ManageRolesSmartview'
import { Translation, Translator } from '@morningtrain/react-translations'
import * as UI from 'ui/index'
import TranslatedTitle from 'widgets/TranslatedTitle'
import PermissionGroupDescription from 'pages/app/settings/permissions/partials/PermissionGroupDescription'
import * as Icons from 'ui/icons'
import ForEachPermission from 'pages/app/settings/permissions/partials/ForEachPermission'
import PermissionGroupRolesSmartview from './smartviews/PermissionGroupRolesSmartview'
import * as Displays from 'support/displays'

export default function PermissionsOverview () {
  return (
    <>

      <Pipeline>
        <TriggerPipelineOnNavigate />
        <MountSmartviewOnPipe smartview={<ManageRolesSmartview />} replace />
      </Pipeline>

      <Translator namespace='settings.permissions'>

        <UI.PageHeader title={(
          <UI.WithSubtitle subtitle={<Translation name='description' />}>
            <TranslatedTitle />
          </UI.WithSubtitle>
                )}
        />

        <ForEachPermission>
          <UI.SpaceBetween>
            <UI.WithSubtitle subtitle={<PermissionGroupDescription />}>
              <Displays.Text name='key'/>

            </UI.WithSubtitle>
            <Pipeline>
              <TriggerPipelineOnClick>
                <UI.SquareButton color='btn-lightgray' className='p-2'>
                  <Icons.SortList />
                </UI.SquareButton>
              </TriggerPipelineOnClick>
              <MountSmartviewWithModelOnPipe smartview={<PermissionGroupRolesSmartview />} replace={false} />
            </Pipeline>
          </UI.SpaceBetween>
        </ForEachPermission>

      </Translator>
    </>
  )
}
